import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';

export const VoiceAcceptButton = ({ onClick }: { onClick: () => void }): React.JSX.Element => {
	return (
		<IconButton
			shape="circle"
			isTooltipDisabled={false}
			icon={(iconProps) => <CheckMarkIcon {...iconProps} label={''} />}
			appearance="primary"
			label="Accept"
			onClick={onClick}
		/>
	);
};
